import React from "react";
import { useLocation } from "react-router-dom";

function PageContent({ children }) {
  const location = useLocation();

  return (
    <div className="app-content content overflow-hidden" style={{ paddingTop: 0, marginTop: 0 }}>
      <div className="content-overlay"></div>
      {/* key on pathname re-runs the entrance animation on each route change */}
      <div className="container-xxl p-0 xv-page" key={location.pathname}>
        {children}
      </div>
    </div>
  );
}

export default PageContent;
